import DialpadIcon from '@mui/icons-material/Dialpad';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from 'components/IconButton/IconButton';
import { CloseIcon } from 'components/icons';
import React from 'react';

const Tab = ({ icon, label, onClick, value, selected }) => {
  const isSelected = value === selected;
  return (
    <Box
      flex={1}
      onClick={() => onClick(value)}
      sx={{
        bgcolor: isSelected ? 'background.paper' : 'background.default',
        cursor: isSelected ? 'default' : 'pointer',
        p: 1.5,
      }}
      borderTop={isSelected ? 0 : 1}
      borderColor="divider"
    >
      <Stack
        spacing={1}
        justifyContent="center"
        direction="row"
        alignItems="center"
      >
        {icon}
        <Typography fontWeight={500}>{label}</Typography>
      </Stack>
    </Box>
  );
};

const BottomTabs = ({ onTabSelect, value }) => {
  return (
    <Box mt="auto" textAlign="center">
      <Stack
        direction="row"
        divider={<Divider flexItem orientation="vertical" />}
      >
        <Tab
          selected={value}
          value="dial"
          onClick={onTabSelect}
          icon={<DialpadIcon color="primary" fontSize="small" />}
          label="Dial"
        />
        <Tab
          selected={value}
          value="audio"
          onClick={onTabSelect}
          icon={<HeadsetMicIcon color="primary" fontSize="small" />}
          label="Audio"
        />
      </Stack>
    </Box>
  );
};

export const TabContent = ({ title, onClose, children }) => {
  return (
    <Paper sx={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{
          bgcolor: 'background.default',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1.5,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          px: 2,
          py: 1,
        }}
      >
        <Typography color="text.secondary" variant="subtitle1" fontWeight={600}>
          {title}
        </Typography>
        <IconButton onClick={onClose} icon={<CloseIcon />} size="small" />
      </Stack>
      <Box p={2}>{children}</Box>
    </Paper>
  );
};

export default BottomTabs;
